<template>
    <div class="team-stats">
        <section class="cl-section">
            <section-heading title="Στατιστικά ομάδας" icon="mdi-chart-box-outline">
                <match-type-choice light :options="['Μέσοι Όροι', 'Σύνολο']" @setType="value => option = value" />
            </section-heading>
            <!-- the team's figures, per game or in total -->
            <div class="team-stats__tiles">
                <div v-for="(stat, index) in stats" :key="stat.key" class="team-stats__tile" :class="{ 'team-stats__tile--lead': index === 0 }">
                    <span class="team-stats__value">{{ display(stat) }}</span>
                    <span class="team-stats__code">{{ stat.value }}</span>
                    <span class="team-stats__label">{{ stat.label }}</span>
                </div>
            </div>
        </section>

        <section class="cl-section">
            <section-heading title="Παίκτες" icon="mdi-account-group-outline" />
            <players-stats :players="players" :option="option" />
        </section>
    </div>
</template>

<script>
    import PlayersStats from '@/components/PlayersStats'
    import SectionHeading from '@/components/SectionHeading'
    import MatchTypeChoice from '@/components/MatchTypeChoice'

    export default {
        components: { PlayersStats, SectionHeading, MatchTypeChoice },
        props: {
            players: {
                type: Array,
                default: null
            },
            matchesPlayed: {
                type: Number,
                default: 1
            },
            type: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                option: 0,
                stats: [
                    { key: 'points', value: 'PTS', label: 'Πόντοι', total: 0 },
                    { key: 'rebounds', value: 'REB', label: 'Ριμπάουντ', total: 0 },
                    { key: 'assists', value: 'AST', label: 'Ασίστ', total: 0 },
                    { key: 'steals', value: 'STL', label: 'Κλεψίματα', total: 0 },
                    { key: 'turnovers', value: 'TO', label: 'Λάθη', total: 0 },
                    { key: 'blockedShots', value: 'BLK', label: 'Τάπες', total: 0 }
                ]
            }
        },
        watch: {
            players: {
                handler() {
                    this.getTotalTeam()
                },
                deep: true
            }
        },
        created() {
            this.getTotalTeam()
        },
        methods: {
            // per game (averages) or the season's total
            display(stat) {
                if (this.option === 0) {
                    return this.matchesPlayed > 0 ? (stat.total / this.matchesPlayed).toFixed(1) : '0.0'
                }
                return stat.total
            },
            getTotalTeam() {
                this.stats.forEach(stat => {
                    stat.total = 0
                    this.players.forEach(player => {
                        player.stats.forEach(match => {
                            stat.total += match[stat.key]
                        })
                    })
                })
            }
        }
    }
</script>

<style scoped>
.team-stats__tiles {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 12px;
}

.team-stats__tile {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 18px 10px 16px;
    border-radius: 12px;
    background: #232323;
    color: #fff;
    box-shadow: 0 6px 20px rgba(35, 35, 35, 0.12);
    overflow: hidden;
}

.team-stats__tile::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background: linear-gradient(90deg, #03e5b7 0%, #037ade 74%);
    opacity: 0.6;
}

.team-stats__tile--lead {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
}

.team-stats__tile--lead::after {
    display: none;
}

.team-stats__value {
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 2.6rem;
    line-height: 1;
}

.team-stats__code {
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    color: #03e5b7;
}

.team-stats__tile--lead .team-stats__code {
    color: #fff;
}

.team-stats__label {
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.6);
}

.team-stats__tile--lead .team-stats__label {
    color: rgba(255, 255, 255, 0.85);
}

@media (max-width: 900px) {
    .team-stats__tiles {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 8px;
    }

    .team-stats__tile {
        padding: 12px 6px 12px;
    }

    .team-stats__value {
        font-size: 2rem;
    }
}
</style>
